import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../aws/AuthContext';
import axios from 'axios';

export const useGetUsuarios = () => {
    const { getJwtToken } = useAuth();
    
    return useQuery({
        queryKey: ['usuarios_lista'],
        queryFn: async () => {
            const token = await getJwtToken();
            const { data } = await axios.get(`${process.env.REACT_APP_API_URL}/v1-usuarios?tipo=lista`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            return data;
        },
        // Mágia: Guarda en caché por 30 minutos. Cero llamados innecesarios a la API.
        staleTime: 1000 * 60 * 30, 
    });
};